import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { FilterLabels } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const ResourceName = ({ isSelected, options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>{FilterLabels.resource}</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<number> & { count: number }, true>
                        id={'battlecards-resource-name'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isMulti
                        options={options}
                        isLoading={isLoading}
                    />
                )}
                name={'resourceName'}
                control={control}
            />
        </div>
    ) : null;
};
